import isMatch from 'lodash/isMatch';
import type { MatcherLocation } from './types.tsx';

// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const cleanPath = (path: string) => path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');

export const matchPathname = (currentUrlPath: string, itemUrlPath: string) =>
	cleanPath(currentUrlPath) === cleanPath(itemUrlPath);

// match just the pathname, ignoring all query parameters
export const matchUrlPathname =
	() => (currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
		matchPathname(currentLocation.pathname, itemLocation.pathname);

// match partial pathname, ignoring all query parameters
export const matchPartialUrlPathname =
	() => (currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
		currentLocation.pathname.includes(itemLocation.pathname);

// match exact pathname and all query parameters defined in the item href
export const matchUrlExact =
	() => (currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
		matchUrlPathname()(currentLocation, itemLocation) &&
		isMatch(currentLocation.query, itemLocation.query);

// match pathname (by default) and specific query parameters
export const matchUrlParams =
	(withParams: string[], withPathname = true) =>
	(currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
		(!withPathname || matchUrlPathname()(currentLocation, itemLocation)) &&
		withParams.every(
			(p) => currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p],
		);
